/**
 * @mergeTarget
 * @module Src/Parameters/String/Options
 */
/**
 * Enumerator of options for {@link Src/Parameters/String.LisioStringParameterNames.THEME} parameter
 * @source
 */
var ThemeOptions;
(function (ThemeOptions) {
    ThemeOptions["C_Y_BG_BL"] = "c_y_bg_bl";
    ThemeOptions["C_BL_BG_W"] = "c_bl_bg_w";
    ThemeOptions["C_W_BG_BK"] = "c_w_bg_bk";
    ThemeOptions["C_W_BG_GY"] = "c_w_bg_gy";
    ThemeOptions["C_BK_BG_W"] = "c_bk_bg_w";
    ThemeOptions["C_BK_BG_G"] = "c_bk_bg_g";
})(ThemeOptions || (ThemeOptions = {}));
export { ThemeOptions };
